import script from "./admin-estimate-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-estimate-detail.vue?vue&type=script&setup=true&lang=js"

import "./admin-estimate-detail.vue?vue&type=style&index=0&id=2c616b86&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c616b86"]])

export default __exports__